import { Component, OnInit, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ViewController, } from 'ionic-angular';

import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { ToastControllerService } from '../../../../../providers/toast-controller.service';
import { Toast508Service } from '../../../../../providers/toast-508.service';
import { SettingsService } from '../../../../../../../UI/src/app/shared/settings/settings.service';

@Component({
  selector: 'page-file-upload',
  templateUrl: 'file-upload-dialog.component.html'
})
export class FileUploadDialogComponent implements OnInit, AfterViewInit {
  fileId: any;
  fileName: string;
  originalFileName: string;
  selectedFile: any;
  alertData: any;
  translations: any;
  private getFileSizeKey = 'ELIXHRUI_SUPPORTED_FILE_SIZE';
  public fileSizeSetting: any;
  private fileSizeExceedMessage: any;
  constructor(private profileService: ProfileService,
    private settingsService: SettingsService,
    private translate: TranslateService,
    private toastService: ToastControllerService,
    public viewCtrl: ViewController,
    private toast508Service: Toast508Service
  ) {
    this.translate.get(['CAREER_INVALID_DOCUMENT', 'CAREER_RESUME_FILE_SIZE']).subscribe((obj) => {
      this.translations = obj;
    });

  }

  ngOnInit() {
    this.settingsService.GetSettings().subscribe(
      settings => {
        this.fileSizeSetting = settings.filter(setting => setting.key === this.getFileSizeKey)[0].value;
        this.fileSizeExceedMessage = this.translations['CAREER_RESUME_FILE_SIZE'].replace('{{limit}}', this.fileSizeSetting / (1024 * 1024));
      }
    );
  }

  ngAfterViewInit(){
    setTimeout(() => {
      let elm = <HTMLDivElement>document.querySelector('ion-modal div');
      elm.setAttribute('tabindex','-1');
      elm.setAttribute('role','dialog');
      elm.focus();
    },300)
  }

  onFileChange(event) {
    if (event && event.target.files) {
      this.alertData = '';
      const fileList: FileList = event.target.files;
      if (fileList.length > 0) {
        const file = fileList[0];
        const filevalid = this.checkFileFormat(file.name, file.size);
        if (filevalid.sizeofFile && filevalid.typeofFile) {
          this.selectedFile = fileList[0];
          this.originalFileName = this.selectedFile.name;
        } else {
          if (!filevalid.typeofFile) {
            this.alertData = { message: this.translations['CAREER_INVALID_DOCUMENT'], type: 'error' };
            this.toastService.presentToast(this.alertData, 'selectFile');
            this.toast508Service.toFocus();
          } else if (!filevalid.sizeofFile) {
            this.alertData = { message: this.fileSizeExceedMessage, type: 'error' };
            this.toastService.presentToast(this.alertData, 'selectFile');
            this.toast508Service.toFocus();
          }
        }
      }
    }
  }

  uploadFile() {
    if (this.fileName && this.selectedFile) {
      const formData: FormData = new FormData();
      formData.append('DisplayName', this.fileName);
      formData.append('Description', this.fileName);
      formData.append('uploadFile', this.selectedFile);
      this.formDataUpload(formData);
    }
  }

  formDataUpload(formData) {
    if (formData) {
      this.profileService.uploadFile(formData).subscribe(
        (response) => {
          if (response) {
            this.fileId = JSON.parse(response.returnData).id;
            if (this.fileId) {
              const file = { fileAssetFK: this.fileId, fileName: this.fileName, originalName: this.originalFileName };
              this.viewCtrl.dismiss(file);
            } else {
            }
          }
        }, (error) => {
        }
      );
    }
  }

  close() {
    this.viewCtrl.dismiss();
  }

  private checkFileFormat(name, size) {
    const docFileParams = {
      fileSize: this.fileSizeSetting ,
      fileType: ['image/*', 'audio/*', 'video/*', 'text/plain', '.doc', '.docm', '.docx', '.xls', '.xlsm', '.xlsx',
        '.oda', '.odc', '.odh', '.odl', '.odp', '.ods', '.odt', '.7z', '.zip', '.rar', '.png', '.gif', '.jpg', '.jpeg',
        '.js', '.css', '.htm', '.html', '.mpg', '.mp4', '.mpeg', '.avi', '.mov', '.mp3', '.wmv', '.pdf', '.txt']
    };
    const fileParams = {
      typeofFile: false,
      sizeofFile: false
    };
    if (docFileParams.fileType.indexOf(name.substring(name.lastIndexOf('.'))) !== -1) {
      fileParams.typeofFile = true;
      if (size <= docFileParams.fileSize) {
        fileParams.sizeofFile = true;
      }
      return fileParams;
    } else {
      return fileParams;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/profile/file-upload/file-upload-dialog.component.ts